import { PartialSuccessResponse } from './partial-success.model';

export function hasFailedEntities(res: PartialSuccessResponse): boolean {
  return !!res?.failed?.length;
}

export function hasSingleError(res: PartialSuccessResponse): boolean {
  return res.total.totalAmount === 1 && res.failed.length === 1;
}
